import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Stethoscope } from "lucide-react";
import api from "../lib/api";
import { Input } from "./ui/input";

export const useMedicoBase = (ospiteId) => useQuery({ queryKey: ["vm-cartella", ospiteId], queryFn: async () => (await api.get("/visite-mediche/cartella", { params: { ospite_id: ospiteId } })).data, enabled: !!ospiteId, staleTime: 60000 }).data?.ospite?.medico_base || "";

export function MedicoPicker({ ospiteId, value, onChange, placeholder = "Nome del medico", className = "h-9", testid = "medico", auto = true }) {
  const base = useMedicoBase(ospiteId);
  const [altro, setAltro] = useState(false);
  const isBase = !!base && value === base && !altro;
  React.useEffect(() => { if (auto && base && !value && !altro) { onChange(base); } }, [base, auto]); // eslint-disable-line react-hooks/exhaustive-deps
  const pill = (on) => `inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold border transition-colors ${on ? "bg-teal-600 text-white border-teal-600" : "bg-white hover:bg-secondary"}`;
  return (
    <div className="space-y-1.5" data-testid={`${testid}-picker`}>
      {base && <div className="flex flex-wrap gap-1.5">
        <button type="button" onClick={() => { setAltro(false); onChange(base); }} className={pill(isBase)} data-testid={`${testid}-base`}><Stethoscope size={12} /> {base} <span className="font-normal opacity-80">· medico di base</span></button>
        <button type="button" onClick={() => { setAltro(true); if (value === base) onChange(""); }} className={pill(altro || (!!value && value !== base))} data-testid={`${testid}-altro`}>Altro medico</button>
      </div>}
      {(!base || !isBase) && <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={className} data-testid={testid} />}
    </div>
  );
}
